// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class Brokers {
    constructor(fieldSourceId) {
        this.BuyerId = 0;
        this.SellerId = 0;
        this.fieldSourceId = fieldSourceId;
        // #68916 нет информации
        if (fieldSourceId === -1 || fieldSourceId === 0) {
            this.BuyerId = this.SellerId = fieldSourceId;
        }
        else {
            // старшие 2 байта - buyer id, младшие 2 байта - seller id
            this.BuyerId = fieldSourceId >> 16;
            this.SellerId = fieldSourceId & 0xffff;
        }
    }
    GetBuyerSellerId() {
        return this.fieldSourceId;
    }
}
